import * as media from '../../assets/career/media';

export interface ICareerValue {
  title: string;
  description: string;
  image: string;
  srcSet: string;
}
export const values: readonly ICareerValue[] = [
  {
    title: 'Масштаб \nвлияния',
    description:
      'Мы создаём решения, которые вплетены в повседневную жизнь миллионов людей. Входим в ТОП-15 самых посещаемых сервисов недвижимости в мире.',
    image: media.mainDrivePhoto1,
    srcSet: [
      media.mainDrivePhoto1P500 + ' 500w',
      media.mainDrivePhoto1P800 + ' 800w',
      media.mainDrivePhoto1P1080 + ' 1080w',
      media.mainDrivePhoto1 + ' 1509w',
    ].join(', '),
  },
  {
    title: 'Радикальная \nчестность',
    description:
      'Никаких подковёрных игр. Мы верим, что прямое общение — кратчайший путь к результату. \n\nПроводим регулярные встречи с топ-менеджментом и не боимся неудобных вопросов.',
    image: media.mainDrivePhoto2,
    srcSet: [
      media.mainDrivePhoto2P500 + ' 500w',
      media.mainDrivePhoto2P800 + ' 800w',
      media.mainDrivePhoto2P1080 + ' 1080w',
      media.mainDrivePhoto2P1600 + ' 1600w',
      media.mainDrivePhoto2 + ' 1658w',
    ].join(', '),
  },
  {
    title: 'Команда, которой \nне всё равно',
    description:
      'Мы работаем с профессионалами, для которых «это не моя задача» — незнакомая фраза. \n\nВ Циане создаются гильдии экспертов, которые вместе решают сложные задачи.',
    image: media.mainDrivePhoto3,
    srcSet: [
      media.mainDrivePhoto3P500 + ' 500w',
      media.mainDrivePhoto3P800 + ' 800w',
      media.mainDrivePhoto3P1080 + ' 1080w',
      media.mainDrivePhoto3 + ' 1562w',
    ].join(', '),
  },
  {
    title: 'Ощутимый вклад \nв продукт',
    description:
      'Голос каждого сотрудника имеет вес. Ты не просто исполняешь ТЗ, ты напрямую влияешь на продукт. \n\nИз инициативы команды на внутреннем хакатоне родился проект Циан.Помощник.',
    image: media.mainDrivePhoto4,
    srcSet: [
      media.mainDrivePhoto4P500 + ' 500w',
      media.mainDrivePhoto4P800 + ' 800w',
      media.mainDrivePhoto4P1080 + ' 1080w',
      media.mainDrivePhoto4 + ' 1544w',
    ].join(', '),
  },
  {
    title: 'Опыт хорошей \nработы',
    description:
      'Это не только конкурентная зарплата, но и здоровая рабочая среда, где ты чувствуешь себя на своём месте. \n\nСредний eNPS 75+.',
    image: media.mainDrivePhoto5,
    srcSet: [
      media.mainDrivePhoto5P500 + ' 500w',
      media.mainDrivePhoto5P800 + ' 800w',
      media.mainDrivePhoto5P1080 + ' 1080w',
      media.mainDrivePhoto5 + ' 1414w',
    ].join(', '),
  },
];
